import * as React from "react";
import { LinkProps } from "../../../../widgets/link/types";

import "./styles.scss";

const classNameBase = "scd-header-link";

interface HeaderLinkProps extends LinkProps {
  icon?: string;
  title?: string;
  disabled?: string;
  className?: string;
}

export default function HeaderLink(props: HeaderLinkProps): React.JSX.Element {
  const {
    id,
    icon,
    href,
    onClick,
    children,
    target,
    title,
    disabled = "",
    className = "",
    rel,
  } = props;

  return (
    <a
      onKeyPress={(e) => {
        if (e.key === "Enter") {
          e.currentTarget.click();
        }
      }}
      tabIndex={0}
      id={id}
      className={`${classNameBase} ${className} ${disabled}`}
      href={href}
      onClick={onClick}
      target={target}
      rel={rel}
      title={title}
    >
      <span className={`link-text`}>{children}</span>
      {icon && <i className={`link-icon ${icon}`} />}
    </a>
  );
}
